import React from 'react';
import './main.css';

export default
class Avatar extends React.Component {
	render(){
		return (
			<img className="avatar" src={this.props.src} alt="User Avatar" />
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Avatar/index.js